import React, { useState } from 'react';
import axios from 'axios';
import '../design/forgotPassword.css';
import Footer from "../components/ui/footer";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    const payload = { email };

    try {
      const response = await axios.post('https://api.deliquentauction.com/auth/forgot-password/', payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setMessage('Password reset email sent! Please check your inbox.');
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setError('Email not found.');
      } else {
        setError('An error occurred. Please try again later.');
      }
    }
  };

  return (
    <div className="forgot-wrapper">
      <div className="forgot-password-container">
        <a href="/">
          <img src="/logo.png" alt="Logo" />
        </a>
        <form onSubmit={handleForgotPassword}>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit">Send Reset Link</button>
        </form>

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        <div>
          <p>Remember your password? <a href="/login">Login</a></p>
        </div>
      </div>
      <div className="forgot-footer">
      <Footer />
    </div>
  </div>
  );
};

export default ForgotPasswordPage;
